<template>
  <div class="p-2" id="healing_log">
    <div class="row">
      <div class="col-12 mb-2">
        <b-input-group>
          <b-form-input
            v-model="search_text"
            placeholder="Search Contractions..."
          ></b-form-input>
          <b-input-group-append>
            <b-button
              variant="outline-secondary"
              class="m-0"
              @click="clearSearchText"
            >
              <i class="fas fa-times"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>

    <div v-if="searching == 1" class="text-muted">
      <i class="fas fa-atom fa-spin"></i> searching
    </div>

    <div
      v-if="feelingContractions !== null && feelingContractions.length > 0"
      class="text-left"
    >
      <b-list-group
        v-for="(contraction, index) in feelingContractions"
        :key="'contraction-' + index"
      >
        <healing-log-item :contraction="contraction" @refreshFeelings="feelingsGet" />
      </b-list-group>
    </div>
    <div v-else>
      <p class="text-muted text-center">No Contractions found</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import HealingLogItem from "./HealingLogItem.vue";
/**
 * Healing Log
 * shows a list of contractions
 */
export default {
  name: "HealingLog",
  components: { HealingLogItem },
  props: {
    userid: {
      type: Number,
      default: null,
    },
    limit: {
      type: Number,
      default: 14,
    },
    readonly: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      search_text: "",
      searching: 1,
      searchFeelingsContractions: [],
    };
  },
  computed: {
    feelingContractions() {
      // filter by search text

      if (! this.search_text) {
        return this.searchFeelingsContractions
      }

      return this.searchFeelingsContractions.filter((feeling) =>
        feeling.contraction?.indexOf(this.search_text) > -1
      );
    },
  },
  methods: {
    feelingsGet(type) {
      console.log("feelingsGet:");
      let _this = this;
      let params = new URLSearchParams();
      params.append("token", this.$store.state.session_id);
      params.append("readonly", this.readonly);

      if (this.userid !== null) {
        params.append("user_id", this.userid);
      }

      params.append("category", "user_feelings_log");

      params.append("limit", this.limit);
      params.append("order_by", "created_at");
      params.append("order_direction", "desc");
      params.append("type", "edit");

      if (type == "search") {
        params.append("search_text", _this.search_text);
      }

      this.history = [];
      this.search_text = "";
      this.searching = 1;

      axios({
        url: _this.$store.state.api_url + "contractions/get",
        params: params,
      })
        .then(function(response) {
          _this.searchFeelingsContractions = response.data;
          _this.searching = 0;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    clearSearchText() {
      this.search_text = "";
    },
  },
  mounted() {
    this.feelingsGet("latest");
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
